import { CircleCheck, CircleX, Info, LoaderCircle, TriangleAlert, X } from "lucide-react";
import { type CSSProperties, type ReactElement, useSyncExternalStore } from "react";
import { Toaster as SonnerToaster } from "sonner";
import { cn } from "@/lib/utils/common";

const TOASTER_STYLE: CSSProperties & { "--width": string } = { "--width": "420px" };

const subscribeToVisibility = (onChange: () => void): (() => void) => {
  document.addEventListener("visibilitychange", onChange);
  return () => document.removeEventListener("visibilitychange", onChange);
};

const isDocumentHidden = (): boolean => document.hidden;

export const Toaster = (): ReactElement => {
  const isHidden = useSyncExternalStore(subscribeToVisibility, isDocumentHidden);

  return (
    <SonnerToaster
      position="bottom-center"
      className={cn("breedr-toaster", { "breedr-toaster--paused": isHidden })}
      style={TOASTER_STYLE}
      visibleToasts={1}
      closeButton
      theme="light"
      icons={{
        success: <CircleCheck className="h-5 w-5" aria-hidden />,
        error: <CircleX className="h-5 w-5" aria-hidden />,
        warning: <TriangleAlert className="h-5 w-5" aria-hidden />,
        info: <Info className="h-5 w-5" aria-hidden />,
        loading: <LoaderCircle className="h-5 w-5 animate-spin" aria-hidden />,
        close: <X className="h-4 w-4" aria-hidden />,
      }}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast: "breedr-toast",
          title: "breedr-toast__title",
          description: "breedr-toast__description",
          actionButton: "breedr-toast__action",
          cancelButton: "breedr-toast__cancel",
          closeButton: "breedr-toast__close",
        },
      }}
    />
  );
};
